import { z } from 'zod';

export const CentPrecisionMoneySchema = z.object({
  cent_amount: z.number(),
  currency_code: z.string(),
  fraction_digits: z.number().optional().default(2),
});
